module.exports = __webpack_public_path__ + "static/media/homeinsurancedoma.ab186c4a.svg";